import React, { useEffect, useState } from 'react';
import '../scss/claimCalculation.scss';
import '../scss/claimPayout.scss'
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { CustomToggle, editModeOn, titleCase } from '../utilFunctions';
import { REACT_APP_VAM_CONTEXT_CALCULATE, REACT_APP_VAM_CONTEXT_PAYMENT, REACT_APP_VAM_ENDPOINT } from '../urls';
import { format } from 'date-fns';
import Dropdown from "react-bootstrap/Dropdown";
import FileUpload from '../utilsComponent/fileUpload';
import TextTruncate from '../utilsComponent/textTruncate';
import Accordion from 'react-bootstrap/Accordion';
import { axiosRequest } from '../service';
import { functionalities, pmfby,rwbcis } from '../consts';
import NoDataFound from '../utilsComponent/noDataFound';
import AsteriskSymbol from '../reusableComponents/AsteriskSymbol'

const ClaimPayout = (props) => {
    const { claimDetailCookie, roleDataCookie } = props
    const navigate = useNavigate()
    const [payoutList, setPayoutList] = useState([])
    const [bankDetails,setBankDetails] =useState([])
    const [clickedOnModity, setClickedOnModity] = useState(false)
    const [clickedOnManualOverview, setClickedOnManualOverview] = useState(false)
    const [paymentDetails, setPaymentDetails] = useState(null)
    const [showUTR, setShowUTR] = useState(false)
    const [addedFiles, setAddedFiles] = useState([])
    const [validtype, setvalidtype] = useState(['image/jpeg', 'image/png', 'image/gif', 'image/jpg', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/tiff', 'video/ogg', 'video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/x-matroska'])
    const [reEnterAccountNumber, setReEnterAccountNumber] = useState("")
    const [approvedNetPayout, setApprovedNetPayout] = useState("")
    const defaultPaymentPayload = {
        "claimID": claimDetailCookie.claimNo,
        "userID": roleDataCookie?.userID,
        "payAmt": paymentDetails ? paymentDetails.payoutAmt : 0,
        "paymentID": "",
        "bankName": "",
        "ifscCode": "",
        "accountType": "",
        "accNumber": "",
        "documents": [],
        "createdBy":roleDataCookie.userID,
        "payeeName": claimDetailCookie.policy?.custmerName
      }
      const govtProducts=[pmfby,rwbcis]
      
    const [paymentPayload, setPaymentPayload] = useState(defaultPaymentPayload)
    
    useEffect(() => {
        // if(claimDetailCookie?.claimApproverStatus?.toLowerCase() !== "completed"){
        //     toast.error("You are not authorized to view this page.")
        //     backPage()
        //     return
        // }else{
        // }
        getPayoutList()
    },[])
    const cancelManualOverRide=()=>{        
        setPaymentPayload(defaultPaymentPayload)
        setClickedOnModity(false)
        setClickedOnManualOverview(false)
    }

    const getPayoutList = () => {
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_CALCULATE}/getCalcHistory/${claimDetailCookie.claimNo}`).then(data => {
            let approvedLists = [...data.data].filter(list => (list.calcEntity.calcStatus.toLowerCase() == "approved"));
            if (approvedLists && approvedLists.length > 0) {
                setApprovedNetPayout(approvedLists[0].calcEntity.netPayout);
            }
        }).catch(error => {
            console.log(error)
        })
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_PAYMENT}/getPaymentHistory/${claimDetailCookie.claimNo}`).then(data => {
            setPayoutList(data.data)
            const paymentDetails = data.data[0]
            setPaymentDetails(data.data[0])
            setPaymentPayload({
                "claimID": claimDetailCookie.claimNo,
                "userID": roleDataCookie?.userID,
                "payAmt": paymentDetails ? paymentDetails.payoutAmt : 0,
                "paymentID": paymentDetails?.paymentID ? paymentDetails?.paymentID :null,
                "bankName": paymentDetails.bankName,
                "ifscCode": paymentDetails.ifscCode,
                "accountType": paymentDetails.accountType,
                "accNumber": paymentDetails.accountNumber,
                "documents": [],
                "createdBy":roleDataCookie.userID,
                "payeeName": claimDetailCookie.policy?.custmerName
            })
            getBankDetails(paymentDetails?.paymentID)
        }).catch(error => {
            console.log(error)
        })
    }
    const getBankDetails = (paymentID) => {
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_PAYMENT}/payout-details?paymentId=${paymentID}&claimId=${claimDetailCookie.claimNo}`).then(data => {
            setBankDetails([data.data])
        }).catch(error => {
            console.log(error)
        })
    }
    const submitPayment = () => {
        if(paymentPayload.accNumber !== reEnterAccountNumber){
            toast.error("Please Check Re-Entered Account Number")
            return
        }
        if(!addedFiles.length){
            toast.error("Please Upload Documents")
            return
        }
        axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_PAYMENT}/modifyPayout`,{ ...paymentPayload, paymentID: payoutList[0]?.paymentID ? payoutList[0]?.paymentID : 999, documents: addedFiles.map(list => String(list.id)), payAmt: approvedNetPayout }).then(data => {
            toast.success("Bank Details Updated Successfully.")
            setReEnterAccountNumber("")
            getPayoutList()
            setAddedFiles([])
        }).catch(error => {
            console.log(error)
        })
    }

    return (
        <div className='inner-box2Field mt-3' >            
               <div className="detailsHistory" style={{height:"100rem"}} >
               {!govtProducts.includes(claimDetailCookie?.productID) && <div className='payout-table'>
                    <div className='header-container'>
                        <div className='header-container-border'>
                            <p>i-Agri</p>
                        </div>
                        <div className='header-container-border'>
                            <p>CMS-Modified</p>
                        </div>
                    </div>
                    <div className='data-container'>
                        <div className='fields-container'>
                            <div>
                                <p>Bank Name : {bankDetails[0]?.iagriBankName ? bankDetails[0]?.iagriBankName : '--'}</p>
                                <p>Account No : {bankDetails[0]?.iagriAccountNumber ? bankDetails[0]?.iagriAccountNumber : '--'}</p>
                                <p>IFSC Code : {bankDetails[0]?.iagriIfscCode ? bankDetails[0]?.iagriIfscCode : '--'}</p>
                            </div>
                        </div>
                        <div className='fields-container'>
                            <div>
                                <p>Bank Name : {bankDetails[0]?.modifiedBankName ? bankDetails[0].modifiedBankName : '--'}</p>
                                <p>Account No : {bankDetails[0]?.modifiedAccountNumber ? bankDetails[0]?.modifiedAccountNumber : '--'}</p>
                                <p>IFSC Code : {bankDetails[0]?.modifiedIfscCode ? bankDetails[0]?.modifiedIfscCode : '--'}</p>
                            </div>
                        </div>
                    </div>
                </div>}
               <div className='d-flex align-items-end justify-content-between'>
                            <h3 className="heading_h2History ms-3 mt-4" id="historyHistory">Claim payout</h3>
                        </div>
                        {
                            showUTR && 
                            <div id="overlay1Calc">
                            <div className='d-inline'>
                            <div className="overlay_textCalc text-right me-3"><span type="button" onClick={() => setShowUTR(false)} className="close" aria-label="Close">
                            <span aria-hidden="true">X</span></span></div>
                                <h1 className='ms-0'> UTR Details </h1>
                                
                            </div>
                            <div className='mt-5'>
                                <h4>Penny Drop</h4>
                                <hr className='w-100'/>
                                <div className="row">
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className="over-headingCalc">
                                            UTR Number
                                        </div>
                                        <div className="over-headingCalc">
                                            {paymentDetails.pennyDropUTRNum ? <TextTruncate text={paymentDetails.pennyDropUTRNum} length={15} />  : "--"}
                                        </div>
                                    </div>
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className="over-headingCalc">
                                            UTR Date & Time
                                        </div>
                                        <div className="over-headingCalc">
                                        {paymentDetails?.pennyDropDateTime ? format(new Date(paymentDetails?.pennyDropDateTime), 'dd-MM-yyyy, hh:mm a') : "--"}
                                        </div>
                                    </div>
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-s  m-6">
                                        <div className="over-headingCalc">
                                            UTR Status
                                        </div>
                                        <div className="over-headingCalc">
                                            {paymentDetails?.pennyDropStatus ? paymentDetails?.pennyDropStatus : "--"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='mt-5'>
                                <h4>Disbursement</h4>
                                <hr className='w-100'/>
                                <div className="row">
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className="over-headingCalc">
                                            UTR Number
                                        </div>
                                        <div className="over-headingCalc">
                                        {paymentDetails.disbursementUTRNum ? <TextTruncate text={paymentDetails.disbursementUTRNum} length={15} />  : "--"}
                                        </div>
                                    </div>
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className="over-headingCalc">
                                            UTR Date & Time
                                        </div>
                                        <div className="over-headingCalc">
                                        {paymentDetails?.disbursementDateTime ? format(new Date(paymentDetails?.disbursementDateTime), 'dd-MM-yyyy, hh:mm a') : "--"}
                                        </div>
                                    </div>
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className="over-headingCalc">
                                            UTR Status
                                        </div>
                                        <div className="over-headingCalc">
                                        {paymentDetails?.disbursementStatus ? paymentDetails?.disbursementStatus : "--"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>                                                           
                        }
                <div>
                    <div className="overflowField"></div>
                    {(payoutList && payoutList.length > 0) || !govtProducts.includes(claimDetailCookie?.productID) ?
                            <table id="claim_historyField" className='mt-4'>
                                <tr>
                                    <th>ID</th>
                                    <th>Initiated By</th>
                                    <th>Initiated Date & Time</th>
                                    <th>Payee Name</th>
                                    <th>Net Pay Out</th>
                                    <th>Status</th>
                                    <th>Remarks</th>
                                    <th>Action</th>
                                </tr>
                                { payoutList && payoutList.length > 0 ? 
                                    payoutList.map(list => (
                                        <tr>
                                            <td className="centerField text-primary" onClick={() => setPaymentDetails(list)}>{list?.paymentID}</td>
                                            <td className="centerField">{list.initiateBy ? list.initiateBy : "--"}</td>
                                            <td className="centerField">{format(new Date(list.initiatedDateTime), 'dd-MM-yyyy, hh:mm a')}</td>
                                            <td className="centerField">{list.payeeName}</td>
                                            <td className="centerField">{list.payoutAmt ? list.payoutAmt : "--"}</td>
                                            <td className="centerField">{list.disbursementStatus}</td>
                                            <td className="centerField">{list.remarks ? <TextTruncate text={list.remarks}length={30}/> : '--'}</td>
                                            <td className="centerField">
                                                <p className="dropdown3Calc mb-0">
                                                    <Dropdown drop='down'>
                                                        <Dropdown.Toggle as={CustomToggle} />
                                                        <Dropdown.Menu size="sm" title="" id="btn_dropdown3Calc" className="dropdown-content3Calc">
                                                        {
                                                            editModeOn(functionalities.MODIFY_PAYOUT) && <> <Dropdown.Item onClick={() => {setClickedOnModity(true);setPaymentDetails(list)}}>Modify Payout</Dropdown.Item> <hr/> </>
                                                        }
                                                        <Dropdown.Item onClick={() => {setPaymentDetails(list);setShowUTR(true)}}>UTR Details</Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </p>
                                            </td>
                                        </tr>
                                    )) :<tr>
                                    <td colSpan="7" className="centerField">
                                     No Payment details found
                                    </td>
                                  <td className="centerField">
                                    <p className="dropdown3Calc mb-0">
                                       
                                        <Dropdown drop='down'>
                                            <Dropdown.Toggle as={CustomToggle} />
                                            <Dropdown.Menu size="sm" title="" id="btn_dropdown3Calc" className="dropdown-content3Calc">
                                                {
                                                    editModeOn(functionalities.MODIFY_PAYOUT) && <Dropdown.Item onClick={() => { setClickedOnModity(true); setPaymentDetails() }}>Modify Payout</Dropdown.Item>
                                                }
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </p>
                                </td></tr>
                                }
                            </table>:<NoDataFound/>
                    }
                </div>
                   {
                    paymentDetails && (
                        <>
                            <Accordion className='mt-5 accordion mx-3'>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    <div className="claim_cal_headerCalc">
                                        <div className="gis-idCalc">Payee & Payment Details</div>
                                    </div></Accordion.Header>
                                <Accordion.Body>
                                <div className = "container-fluid mt-5">
                                <div id = "result-table-rowCalc" className = "row">
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className = "query-headingCalc">
                                            Payment Mode
                                        </div>
                                        <div className = "query-answerCalc">
                                            {paymentDetails.payoutMode}
                                        </div>
                                    </div>
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className = "query-headingCalc">
                                            Payee Name
                                        </div>
                                        <div className = "query-answerCalc">
                                            {paymentDetails.payeeName}
                                        </div>
                                    </div>
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className = "query-headingCalc">
                                            Pan Number
                                        </div>
                                        <div className = "query-answerCalc">
                                            {paymentDetails.panNumber ? paymentDetails.panNumber : "--"}
                                        </div>
                                    </div>
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className = "query-headingCalc">
                                            Net Payout
                                        </div>
                                        <div className = "query-answerCalc">
                                            {paymentDetails.payoutAmt}
                                        </div>
                                    </div>
                                </div>
                                <div id = "result-table-rowCalc" className = "row">
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className = "query-headingCalc">
                                            Balance Check Status
                                        </div>
                                        <div className = "query-answerCalc">
                                            {paymentDetails.balanceStatus}
                                        </div>
                                    </div>
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className = "query-headingCalc">
                                            Penny Drop Amount
                                        </div>
                                        <div className = "query-answerCalc">
                                        {paymentDetails?.pennyDropAmt ? paymentDetails?.pennyDropAmt : "--"}
                                        </div>
                                    </div>
                                    {!govtProducts.includes(claimDetailCookie?.productID) &&
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className = "query-headingCalc">
                                            Penny Initiated Date
                                        </div>
                                        <div className = "query-answerCalc">
                                        {paymentDetails?.pennyDropDateTime ? format(new Date(paymentDetails?.pennyDropDateTime), 'dd-MM-yyyy, hh:mm a') : "--"}
                                        </div>
                                    </div>}
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                    </div>
                                </div>
                                <div id = "result-table-rowCalc" className = "row">
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className = "query-headingCalc">
                                            Penny Drop Status
                                        </div>
                                        <div className = "query-answerCalc">
                                        {paymentDetails?.pennyDropStatus ? paymentDetails?.pennyDropStatus : "--"}
                                        </div>
                                    </div>
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className = "query-headingCalc">
                                            Disbursement Amount
                                        </div>
                                        <div className = "query-answerCalc">
                                        {paymentDetails?.disbursementAmt ? paymentDetails?.disbursementAmt : "--"}
                                        </div>
                                    </div>
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className = "query-headingCalc">
                                            Disbursement Initiated Date
                                        </div>
                                        <div className = "query-answerCalc">
                                        {paymentDetails?.disbursementDateTime ? format(new Date(paymentDetails?.disbursementDateTime), 'dd-MM-yyyy, hh:mm a') : "--"}
                                        </div>
                                    </div>
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                    </div>
                                </div>
                                <div id = "result-table-rowCalc" className = "row">
                                    <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div className = "query-headingCalc">
                                            Disbursement Status
                                        </div>
                                        <div className = "query-answerCalc">
                                            {paymentDetails.disbursementStatus}
                                        </div>
                                    </div>
                                </div>
                                </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion> 
                                            
                        </>
                    )}  
  {
                            clickedOnModity  && (
                            <Accordion activeKey='0' className='mt-5 accordion mx-3'>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <div className="claim_cal_headerCalc">
                                            <div className="gis-idCalc">Bank Details</div>
                                        </div></Accordion.Header>
                                    <Accordion.Body>
                                        {
                                            roleDataCookie?.roleName !== "CALL_CENTRE" && claimDetailCookie?.claimStatus?.toLowerCase() !== "closed" && ( !paymentDetails|| paymentDetails?.pennyDropStatus?.toLowerCase()=='failed' || paymentDetails?.pennyDropStatus?.toLowerCase()=='rejected' || paymentDetails?.disbursementStatus?.toLowerCase() =='failed' || paymentDetails?.disbursementStatus?.toLowerCase() =='rejected') && (
                                                <div style={{display: "flex", flexDirection: "row", alignItems: "center"}} className='mt-5'>
                                                    <input type="checkbox" style={{width: "16px", height: "32px"}} onChange={() => setClickedOnManualOverview(!clickedOnManualOverview)}/>
                                                    <h1 style={{fontSize: "20px", marginTop: "5px", marginLeft: "3px"}}>Manual Override</h1>
                                                </div>
                                            )
                                        }
                                      
                            

                                        <div className="container-fluid align-result-tableCalc mt-1">
                                            <div id="result-table-row1Calc" className="row mt-2">
                                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                                    <div className="query-headingCalc">
                                                        Bank Name <AsteriskSymbol/>
                                                    </div>
                                                    <div>
                                                        <input type="text" id="bankinput" value={paymentPayload.bankName} placeholder="SBI" disabled={(!clickedOnManualOverview || !clickedOnModity)} onChange={(e) => setPaymentPayload({...paymentPayload, bankName: e.target.value})}/>
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                                    <div className="query-headingCalc">
                                                        IFSC Code <AsteriskSymbol/>
                                                    </div>
                                                    <div>
                                                        <input type="text" id="bankinput" placeholder="SBI001" value={paymentPayload.ifscCode} disabled={(!clickedOnManualOverview || !clickedOnModity)} onChange={(e) => setPaymentPayload({...paymentPayload, ifscCode: e.target.value})}/>
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                                    <div className="query-headingCalc">
                                                        Account Type <AsteriskSymbol/>
                                                    </div>                                      
                                                        <select id="bankinput" className='w-75' value={titleCase(paymentPayload.accountType)} disabled={(!clickedOnManualOverview || !clickedOnModity)} onChange={(e) => setPaymentPayload({...paymentPayload, accountType: e.target.value})}>
                                                           <option value="" disabled>select account type</option>
                                                            <option value="Savings">Savings</option>
                                                            <option value="Current">Current</option>
                                                        </select>
                                                </div>
                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                                    <div className="query-headingCalc">
                                                        Account Number <AsteriskSymbol/>
                                                    </div>
                                                    <div>
                                                        <input type="text" id="bankinput" placeholder="123456" value={titleCase(paymentPayload.accNumber)}  disabled={(!clickedOnManualOverview || !clickedOnModity)} onChange={(e) => 
                                                              {const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                                              e.target.value = numericValue;
                                                            setPaymentPayload({...paymentPayload, accNumber: e.target.value})}}/>
                                                    </div>
                                                </div>
                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 mt-2">
                                                            <div className="query-headingCalc">
                                                                Re-Enter Bank Account Number <AsteriskSymbol/>
                                                            </div>
                                                            <div>
                                                                <input type="password" id="bankinput" placeholder="****"  disabled={(!clickedOnManualOverview || !clickedOnModity)} onChange={(e) => 
                                                                     {const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                                                     e.target.value = numericValue;
                                                                    setReEnterAccountNumber(e.target.value)}}/>
                                                            </div>
                                                        </div>
                                                 
                                            </div>
                                        </div>
                                       
                                        <div className='mt-5'>
                                        {
                                            roleDataCookie?.roleName !== "CALL_CENTRE" && claimDetailCookie?.claimStatus?.toLowerCase() !== "closed" && (!paymentDetails ||paymentDetails?.pennyDropStatus?.toLowerCase()=='failed' || paymentDetails?.pennyDropStatus?.toLowerCase()=='rejected' || paymentDetails?.disbursementStatus?.toLowerCase() =='failed' || paymentDetails?.disbursementStatus?.toLowerCase() =='rejected') && (
                                              <>
                                                <h2 className="documentsField">Documents</h2>
                                            
                                                        <div className="row">
                                                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                                            <FileUpload mandatory={true} validtype={validtype} addedFiles={addedFiles} setAddedFiles={setAddedFiles} text={"Upload File"} module="litigation" roleDataCookie={roleDataCookie} tran_id={claimDetailCookie.claimNo} doctypeName="payment" pay/>
                                                            
                                                                {/* <div class="align1_dataField survey_box1Field">
                                                                    <div class="survey_box2Field">
                                                                        <div class="uploaded_imgField">
                                                                            <img src="/kshemaImages/entire_agricultural_field.jpg" height="110px" width="100%"
                                                                                class="center-imgField" alt='' style={{borderRadius: "8px"}} />
                                                                            <img src="/kshemaImages/delete_cross.png" alt='' height="16px" width="16px" title="delete"
                                                                                class="delete_crossField" />
                                                                        </div>
                                                                    </div>
                                                                    <div class="img_descriptionField">Entire Field Photos <span class="asteriskField"></span>
                                                                    </div>
                                                                </div> */}
                                                            </div>
                                                            {/* <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                                                <div class="align1_dataField survey_box1Field">
                                                                    <div class="survey_box2Field">
                                                                        <div class="uploaded_imgField">
                                                                            <img src="/kshemaImages/after_loss.jpg" height="110px" width="100%" class="center-imgField" />
                                                                            <img src="/kshemaImages/delete_cross.png" height="16px" width="16px" title="delete"
                                                                                class="delete_crossField" />
                                                                        </div>
                                                                    </div>
                                                                    <div class="img_descriptionField">Loss Affected Area Photo <span
                                                                        class="asteriskField"></span></div>
                                                                </div>
                                                            </div> */}
                                                        </div>
                                              
                                              </>
                                            )
                                        }
                                            
                                        
                                    <div className="d-flex mx-3">
                                    {
                                           roleDataCookie?.roleName !== "CALL_CENTRE" && claimDetailCookie?.claimStatus?.toLowerCase() !== "closed" && (!paymentDetails || paymentDetails?.pennyDropStatus?.toLowerCase()=='failed' || paymentDetails?.pennyDropStatus?.toLowerCase()=='rejected' || paymentDetails?.disbursementStatus?.toLowerCase() =='failed' || paymentDetails?.disbursementStatus?.toLowerCase() =='rejected') && (
                                            <>
                                            <div className="form-group">
                                                <div className="btn btn-outline-success mt-4 mb-0 px-4" onClick={cancelManualOverRide}>Cancel</div>
                                            </div>
                                            <div className="form-group">
                                                <button className="btn btn-success m-4 mb-0 px-4" disabled={!clickedOnManualOverview || !clickedOnModity || (claimDetailCookie?.claimSubStatus !=="Account Details Missing" &&(!paymentPayload.bankName || !paymentPayload.ifscCode || !paymentPayload.accountType || !paymentPayload.accNumber)) } onClick={() => submitPayment()}>Submit</button>
                                            </div>
                                            </>
                                          )
                                        }
                                </div>
                                    </div>       
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>                          
                          )
                        }    
            </div>
       
        </div>
    )
}

export default ClaimPayout
